/*
 * Public API Surface of hero
 */

export * from './hero.module';
export * from './hero.component';
export * from './hero-banner.component';
